module.exports = __webpack_public_path__ + "static/media/StoreArrow.fe0caa3f.svg";